export const ACTIONS = {
  create: { label: 'Création', verb: 'a créé', color: 'green' },
  update: { label: 'Modification', verb: 'a modifié', color: 'blue' },
  delete: { label: 'Suppression', verb: 'a supprimé', color: 'red' },
  upsert: { label: 'Création ou modification', verb: 'a créé ou modifié', color: 'purple' },
  updateMany: { label: 'Modification en lot', verb: 'a modifié en lot', color: 'blue' },
  deleteMany: { label: 'Suppression en lot', verb: 'a supprimé en lot', color: 'red' },
};

export const MODELS = {
  Bonliv: 'Bon de livraison', Facture: 'Facture', Devis: 'Devis', Avoirs: 'Avoir client',
  Client: 'Client', Article: 'Article', User: 'Utilisateur', Stock: 'Stock', Comercial: 'Commercial',
  Fournisseur: 'Fournisseur', Entrepot: 'Entrepôt', Reglement: 'Règlement', Surplus: 'Surplus',
  CommandeAchat: 'Commande fournisseur', BonReception: 'Bon de réception', FactureAchat: 'Facture fournisseur',
  AvoirAchat: 'Avoir fournisseur', Transfert: 'Transfert de stock', famille: 'Famille', SousFamille: 'Sous-famille',
  Inventaire: 'Inventaire', EntInventaire: 'Entrepôt d’inventaire', DetInventaire: 'Ligne d’inventaire',
  CorrectionStock: 'Correction de stock', CorrectionStockDetail: 'Ligne de correction de stock',
  Demarque: 'Démarque', DemarqueDetail: 'Ligne de démarque', JournalExp: 'Journal d’expédition',
  UnifiedFactureAvoir: 'Registre des factures et avoirs', Template: 'Modèle de document', AppSetting: 'Paramètre',
  UserPermission: 'Permission utilisateur', PermissionGroup: 'Groupe de permissions',
  PermissionGroupGrant: 'Permission de groupe', UserPermissionGroup: 'Affectation à un groupe',
  DeliveryMode: 'Mode de livraison', PaymentMode: 'Mode de paiement', Country: 'Pays', City: 'Ville', Bank: 'Banque',
  CommandeAchatDetail: 'Ligne de commande fournisseur', DetailBonReception: 'Ligne de réception',
  DetailFactureAchat: 'Ligne de facture fournisseur', DetailAvoirAchat: 'Ligne d’avoir fournisseur',
  TransfertDetail: 'Ligne de transfert', BonlivPerEtage: 'Livraison par étage', Counter: 'Compteur',
  DevisCheck: 'Vérification de devis', dbfCheck: 'Vérification d’import',
};
const FIELDS = {
  status: 'Statut', VALIDER: 'Validé', TRANSFERER: 'Transféré', EN_FACTURE: 'Facturé',
  REF_BL: 'Référence du bon de livraison', REF_FAC: 'Référence de facture', REF_DEV: 'Référence du devis',
  REF_AVR: 'Référence de l’avoir', REF_BR_A: 'Référence de réception', REF_BC_A: 'Référence de commande',
  CLIENT: 'Client', CODE_CLT: 'Code client', CODE_ART: 'Code article', code_art: 'Code article',
  FOURNISSEUR: 'Fournisseur', CODE_FRS: 'Code fournisseur', CODE_ENT: 'Code entrepôt', code_ent: 'Code entrepôt',
  QTE: 'Quantité', qte_stk: 'Quantité en stock', qte_liv: 'Quantité livrée', qte_controle: 'Quantité contrôlée',
  PU: 'Prix unitaire', PRIX: 'Prix', REMISE: 'Remise', TVA: 'TVA', TOTAL: 'Total', MONTANT: 'Montant',
  SOLDE: 'Solde', COMPTE: 'Compte', DESIGNATION: 'Désignation', designation: 'Désignation',
  DATE_BL: 'Date de livraison', DATE_FAC: 'Date de facture', DATE_DEV: 'Date du devis',
  Name: 'Nom', Email: 'E-mail', UserID: 'Identifiant utilisateur', id: 'Identifiant',
  createdAt: 'Date de création', updatedAt: 'Dernière modification', CreatedAt: 'Date de création', UpdatedAt: 'Dernière modification',
  isCold: 'Archivé', count: 'Nombre d’éléments', active: 'Actif', name: 'Nom', desc: 'Description',
};
const STATUSES = { EN_PREPARATION: 'En préparation', PREPARE: 'Préparé', VALIDE: 'Validé', TRANSFERE: 'Transféré', GROUPE: 'Groupé', BROUILLON: 'Brouillon', ANNULE: 'Annulé' };
const MODEL_REFERENCE = { Bonliv: 'REF_BL', Facture: 'REF_FAC', Devis: 'REF_DEV', Avoirs: 'REF_AVR', BonReception: 'REF_BR_A', CommandeAchat: 'REF_CA', FactureAchat: 'REF_FAC_A', AvoirAchat: 'REF_AVR_A', Transfert: 'REF_TRF', Reglement: 'REF_REGV', Demarque: 'REF_DEM', CorrectionStock: 'REF_COR', Surplus: 'REF_SURPLUS', UnifiedFactureAvoir: 'currentRef' };
const REFERENCE_FIELDS = ['REF_BL', 'REF_FAC', 'REF_DEV', 'REF_AVR', 'REF_BR_A', 'REF_CA', 'REF_FAC_A', 'REF_AVR_A', 'REF_AV_FAC', 'currentRef', 'CODE_CLT', 'code_art', 'CODE_ART', 'CODE_FRS', 'Email', 'id', 'UserID'];
const secret = /password|passwordhash|motdepasse|token|secret/i;
export const modelLabel = model => MODELS[model] || model || 'Élément';
export const actionInfo = action => ACTIONS[action] || { label: action || 'Opération', verb: 'a effectué une opération sur', color: 'default' };
export const fieldLabel = field => FIELDS[field] || field.replace(/_/g, ' ');
export const actorName = row => row.userName || row.userEmail || (row.userId != null ? `Utilisateur #${row.userId}` : 'Système');

export function referenceLabel(row) {
  for (const field of [MODEL_REFERENCE[row.model], ...REFERENCE_FIELDS].filter(Boolean)) {
    for (const source of [row.after, row.targetWhere, row.before]) {
      if (source?.[field] !== undefined && source[field] !== null && typeof source[field] !== 'object') return String(source[field]);
    }
  }
  return '';
}

export function redact(value) {
  if (Array.isArray(value)) return value.map(redact);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, secret.test(key) ? '••••••' : redact(val)]));
  return value;
}

export function displayValue(value, field = '') {
  if (secret.test(field)) return '••••••';
  if (value === undefined || value === null || value === '') return 'Non renseigné';
  if (typeof value === 'boolean') return value ? 'Oui' : 'Non';
  if (typeof value === 'object') return JSON.stringify(redact(value), null, 2);
  if (field === 'status' && STATUSES[value]) return STATUSES[value];
  return String(value);
}

export function changesFor(row) {
  if (!row.success || /Many$/.test(row.action)) return [];
  // A missing snapshot is not evidence that every field was added or removed.
  if (['update', 'upsert'].includes(row.action) && (!row.before || !row.after)) return [];
  const before = row.before || {};
  const after = row.after || {};
  return [...new Set([...Object.keys(before), ...Object.keys(after)])]
    .filter(field => JSON.stringify(before[field]) !== JSON.stringify(after[field]))
    .map(field => ({ field, before: before[field], after: after[field] }));
}

export function activitySummary(row) {
  const ref = referenceLabel(row);
  const target = `${modelLabel(row.model)}${ref ? ` · ${ref}` : ''}`;
  if (!row.success) return `${actorName(row)} — échec : ${actionInfo(row.action).label.toLowerCase()} · ${target}`;
  return `${actorName(row)} ${actionInfo(row.action).verb} : ${target}`;
}

export function changeSummary(row) {
  if (!row.success) return 'L’opération a échoué. Consultez le détail de l’erreur.';
  if (/Many$/.test(row.action)) return row.after?.count !== undefined ? `${row.after.count} élément(s) concerné(s) · détail par élément non enregistré` : 'Opération en lot · détail par élément non enregistré';
  if (row.action === 'create') return 'Nouvel élément enregistré';
  if (row.action === 'delete') return 'Élément supprimé';
  if (!row.before || !row.after) return 'Comparaison indisponible : état avant ou après non enregistré';
  const changes = changesFor(row);
  const status = changes.find(change => change.field === 'status' || change.field === 'VALIDER');
  if (status) return `${fieldLabel(status.field)} : ${displayValue(status.before, status.field)} → ${displayValue(status.after, status.field)}`;
  if (!changes.length) return 'Aucune différence dans les données enregistrées';
  return `${changes.length} champ(s) modifié(s) : ${changes.slice(0, 3).map(change => fieldLabel(change.field)).join(', ')}${changes.length > 3 ? '…' : ''}`;
}
